import * as accountsApi from '@/network/api/accounts.api.js'
import * as transfersApi from '@/network/api/transfers/transfers.api.js'
import * as apiFavorites from '@/network/api/favorites.api.js'
import * as beneficiariesApi from '@/network/api/transfers/beneficiaries.api.js'
import * as smartTransfersApi from '@/network/api/smartTransfers.api.js'
import * as recurringApi from '@/network/api/transfers/recurring.api.js'
import * as operationsApi from '@/network/api/operations/operations.api.js'

/** requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountsApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCES', data)
    }
    return res
}

/** request Beneficiary Destination Info
@return {promise} - Beneficiary Destination Info
*/
export const requestBeneficiaryDestinationInfo = async (context, payload) => {
    const res = await beneficiariesApi.getBeneficiaryDestinationInfo(payload)

    return res
}

/** request Beneficiary Destination Info
@return {promise} - Beneficiary Destination Info
*/
export const requestBeneficiaryName = async (context, payload) => {
    const res = await beneficiariesApi.getBeneficiaryName(payload)

    return res
}

/** Requests Transfers RTGS Status
@return {promise} - Transfers RTGS Status request
*/
export const requestTransfersRTGS = async () => {
    const res = await transfersApi.getTransfersRTGS()

    return res
}

/** Requests Schedule Types
@return {promise} - Schedule Types request
*/
export const requestTransfersScheduleTypes = async (context) => {
    const res = await transfersApi.getTransfersScheduleTypes()
    if (res) context.commit('SAVE_SCHEDULE_TYPES', res.data.data)

    return res
}

export const requestTansfersCategoriesList = async (context, payload) => {
    const res = await transfersApi.getTransfersCategoriesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFERS_CATEGORIES_LIST', data)
    }
    return res
}

/** requests transfers motives list
@return {promise} - Transfers motives list request
*/
export const requestTransfersMotivesList = async (context, payload) => {
    const res = await transfersApi.getTransfersMotivesListForTransferCategory(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFERS_MOTIVES_LIST', data)
    }
    return res
}

/** requests transfers operations
@return {promise} - Transfer operation list request
*/
export const requestTransfersOperationsList = async (context, payload) => {
    const res = await operationsApi.getOperationHistoryList(payload)
    if (res) {
        const data = res.data.data
        context.commit('TRANSFERS_OPERATIONS_LIST', data)
    }
    return res
}

/** Requests Transfers List
@return { promise } - Transfers list request
*/
export const requestTransfersList = async (context, payload) => {
    const res = await transfersApi.getTransfersList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFERS_LIST', data)
    }
    return res
}

/** requests Last Transfers List
@return {promise} - Last Transfers List
*/
export const requestSmartTransfersSubmissionsSentList = async (context, payload) => {
    const res = await smartTransfersApi.getSmartTransfersSubmissionsSentList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_SMART_TRANSFERS_LIST', data)
    }
    return res
}

/** requests favorites list
@payload { Object }
@return { promise } -  favorites list request
*/
export const requestFavoritesList = async (context, payload) => {
    const res = await apiFavorites.getFavoritesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_FAVORITES_LIST', { pageNumber: payload.pageNumber, data: data })
    }
    return res
}

/** requests beneficiaries list
@return { promise } - Beneficiaries list request
*/
export const requestBeneficiariesList = async (context, payload) => {
    const res = await beneficiariesApi.requestBeneficiariesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_BENEFICIARIES_LIST', data)
    }
    return res
}

/** requests beneficiaries list by data type
@return { promise } - Beneficiaries list by data type request
*/
export const requestBeneficiariesListByDataType = async (context, payload) => {
    const res = await beneficiariesApi.requestBeneficiariesListByDataType(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_BENEFICIARIES_LIST', data)
    }
    return res
}

/** request to create pontual transfer
@return { promise } - Create pontual transfer request
*/
export const createPontualTransfer = async (context, payload) => {
    const res = await transfersApi.createPontualTransfer(payload)

    return res
}

/** request to create recurring transfer
@return { promise } - Create recurring transfer request
*/
export const createRecurringTransfer = async (context, payload) => {
    const res = await recurringApi.createRecurringTransfer(payload)

    return res
}

/** submit Smart Transfer
@return { promise }
*/

export const createSmartTransfer = async (context, payload) => {
    const res = await smartTransfersApi.createSmartTransferSendMoney(payload)
    return res
}

/** Creates Beneficiary
@return { promise } - Create Beneficiary
*/
export const createBeneficiary = async (context, payload) => {
    const res = await beneficiariesApi.createBeneficiary(payload)

    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
